export default "__VITE_ASSET__ea671417__"